module.exports = __webpack_public_path__ + "img/no_internet.de334915.svg";